import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Form, Input, Icon, Col, Upload, Row, Button, Divider, Radio, Switch, Modal, List, Select } from 'antd';
import OrgOUMultiSelector from '../../../components/OrgOUMultiSelector';
import { getOrgNationalMapDetails, removeNationalMapSite, saveNationalMapSite, updateOrgCustomFeatures } from '../actions/orgActions';
import { CONNECT_CUSTOM_FEATURES_STATUS, NATIONAL_MAP_INSTANCES, SITE_TYPE } from '../constants';
import ConnectLoading from '../../../components/ConnectLoading';
import NationalMapDetailView from './NationalMapDetailView';

const FormItem = Form.Item;
const { Option } = Select;
const NATIONAL_MAP_CUSTOM_FEATURES_KEY = 'NATIONAL_MAP';

class NationalMapSiteDetailsForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            savingChanges: false,
            instanceType: 'GOLF',
            isLoading: true,
            isNationalMapEnabled: false,
            isShowOuSelector: false,
            nationalMapSiteType: undefined,
            profileImage: undefined,
            bannerImage: undefined,
            climateChampionImage: undefined,
            nationalMapSites: [],
            selectedSite: undefined,
            selectedOus: [],
            ouIds: []
        }
    }

    componentDidMount = async () => {
        await this.loadNationalMapDetails();
    }

    loadNationalMapDetails = async () => {
        const { orgCustomFeatures } = this.props.orgInfo;
        const isNationalMapEnabled = orgCustomFeatures.length > 0 && orgCustomFeatures.includes(NATIONAL_MAP_CUSTOM_FEATURES_KEY);
        if (isNationalMapEnabled) {
            const nationalMapSites = await getOrgNationalMapDetails(this.props.orgId);
            if (nationalMapSites.length > 0) {
                const nationalMapSite = nationalMapSites[0];
                const { siteType, instanceType } = nationalMapSite;
                const selectedSite = siteType === SITE_TYPE.ORG_LEVEL ? nationalMapSite : undefined;
                this.setState({
                    nationalMapSiteType: siteType,
                    instanceType,
                    selectedSite,
                    isNationalMapEnabled,
                    nationalMapSites
                });
            }
            else {
                this.setState({
                    nationalMapSiteType: undefined,
                    selectedSite: undefined,
                    isNationalMapEnabled: false,
                    nationalMapSites: []
                });
            }
        }
        this.setState({ isLoading: false });
    }

    handleCancel = () => {
        this.props.form.resetFields();
        this.setState({
            nationalMapSiteType: undefined,
            bannerImage: undefined,
            profileImage: undefined,
            climateChampionImage: undefined,
            instanceType: 'GOLF',
            selectedOus: [],
            ouIds: []
        });
        this.loadNationalMapDetails();
    }

    handleSubmit = () => {
        const { form, orgInfo, orgId } = this.props;
        form.validateFields(async (err, values) => {
            if (err) {
                return;
            }
            const { siteName, shortDescription, siteDescription, website, contactNumber, climateChampionName, climateChampionDescription } = values;
            const { profileImage, bannerImage, climateChampionImage, nationalMapSiteType, ouIds } = this.state;
            const climateChampions = [];

            if (climateChampionName) {
                climateChampions.push({ climateChampionName, climateChampionDescription })
            }
            const nationalMapSite = {
                properties: {
                    siteName,
                    shortDescription,
                    siteDescription,
                    website,
                    contactNumber
                },
                team: { climateChampions },
                ouIds,
                instanceType: this.state.instanceType,
                siteType: nationalMapSiteType,
                orgCode: orgInfo.org_code
            }
            const customFeatureInfo = {
                status: CONNECT_CUSTOM_FEATURES_STATUS.ENABLE,
                feature: NATIONAL_MAP_CUSTOM_FEATURES_KEY,
            }
            await saveNationalMapSite(orgId, nationalMapSite, { profileImage, bannerImage, climateChampionImage });
            await updateOrgCustomFeatures(orgId, customFeatureInfo);
            this.handleCancel();
        });

    }

    beforeUploadProfileImage = (imageFile) => {
        const reader = new FileReader();
        reader.readAsDataURL(imageFile);
        reader.onloadend = () => {
            imageFile.url = reader.result;
            this.setState({ profileImage: imageFile });
        }
    }

    beforeUploadBannerImage = (imageFile) => {
        const reader = new FileReader();
        reader.readAsDataURL(imageFile);
        reader.onloadend = () => {
            imageFile.url = reader.result;
            this.setState({ bannerImage: imageFile });
        }
    }

    beforeUploadClimateChampionImage = (imageFile) => {
        const reader = new FileReader();
        reader.readAsDataURL(imageFile);
        reader.onloadend = () => {
            imageFile.url = reader.result;
            this.setState({ climateChampionImage: imageFile });
        }
    }

    handleSelectOus = () => {
        const ouIds = [];
        this.state.selectedOus.map(ou => ouIds.push(ou.ouId))
        this.setState({ isShowOuSelector: false, ouIds });
    }

    onEnableDisableSite = (status) => {
        const orgId = this.props.orgId;
        const current = this;
        Modal.confirm({
            title: 'Confirm',
            content: (
                <div>
                    <p>{`Are you sure you want to ${status ? 'enable' : 'disable'} National Map?`}</p>
                </div>
            ),
            async onOk() {
                if (status) {
                    current.setState({
                        isNationalMapEnabled: !current.state.isNationalMapEnabled,
                        nationalMapSiteType: undefined
                    });
                }
                else {
                    const customFeatureInfo = {
                        status: CONNECT_CUSTOM_FEATURES_STATUS.DISABLE,
                        feature: NATIONAL_MAP_CUSTOM_FEATURES_KEY,
                    }
                    await Promise.all(current.state.nationalMapSites.map(async site => {
                        await removeNationalMapSite(orgId, site.siteId, site.instanceType);
                    }))
                    await updateOrgCustomFeatures(orgId, customFeatureInfo);
                    await current.loadNationalMapDetails();
                }
            },
            async onCancel() {
                console.log('Canceled');
            },
        });
    }

    orgOuSelector = () => {
        return (
            <Modal
                visible={this.state.isShowOuSelector}
                title="Create OU Group"
                checked={this.state.nationalMapSiteDetails}
                onCancel={() => this.setState({ isShowOuSelector: false })}
                onOk={this.handleSelectOus}
            >
                <OrgOUMultiSelector
                    onValue={selectedOus => this.setState({ selectedOus })}
                    orgId={this.props.orgId}
                    selectedOus={this.state.selectedOus}
                    isNationalMapForm={true}
                />
            </Modal>
        );
    }

    orgGroupListView = () => {
        return (
            <div>
                {
                    (this.state.nationalMapSiteType === SITE_TYPE.OU_LEVEL && this.state.nationalMapSites.length > 0) &&
                    <Col className="epar_national_map_row" sm={24} md={12}>
                        <p className="epar_national_map_label">Organization Unit Groups :</p>
                        <List
                            size="small"
                            style={{ padding: 0 }}
                            bordered
                            dataSource={this.state.nationalMapSites}
                            renderItem={item => (
                                <List.Item onClick={() => this.setState({ selectedSite: item })}>
                                    {item.properties.siteName}
                                </List.Item>
                            )}
                        />
                    </Col>
                }
            </div>
        );
    }

    addNationalMapSiteForm = () => {
        const { form } = this.props;
        const { getFieldDecorator } = form;
        const profileImage = this.state.profileImage && this.state.profileImage.url;
        const bannerImage = this.state.bannerImage && this.state.bannerImage.url;
        const climateChampionImage = this.state.climateChampionImage && this.state.climateChampionImage.url;
        const uploadButton = (
            <div>
                <Icon type={this.state.loading ? 'loading' : 'plus'} />
                <div className="ant-upload-text">Upload</div>
            </div>
        );
        return (
            <div>
                {

                    (this.state.ouIds.length > 0 ||
                        (this.state.nationalMapSiteType === SITE_TYPE.ORG_LEVEL && this.state.nationalMapSites.length === 0)) &&
                    <Form layout="vertical">
                        <Divider />
                        <div className='epar_national_map'>
                            <Col sm={24} md={12} style={{ paddingInline: 10 }}>
                                <p className='epar_national_map_form_category'>General Details</p>
                                <FormItem label="National Map Site Name">
                                    {getFieldDecorator('siteName', {
                                        rules: [{ required: true, message: 'Please enter site name!' }],
                                    })(
                                        <Input placeholder="Enter site name" />
                                    )}
                                </FormItem>
                                <FormItem label="Short Description">
                                    {getFieldDecorator('shortDescription', {
                                        rules: [{ required: true, message: 'Please enter short description!' }],
                                    })(
                                        <Input.TextArea placeholder="Enter short description" />
                                    )}
                                </FormItem>
                                <FormItem label="Description">
                                    {getFieldDecorator('siteDescription', {
                                        rules: [
                                            { required: true, message: 'Please enter site description!' },
                                            { min: 100, message: 'Site description must be minimum 100 characters.' },
                                        ],
                                    })(
                                        <Input.TextArea placeholder="Enter site description" />
                                    )}
                                </FormItem>
                                <FormItem label="Traditional Custodians">
                                    {getFieldDecorator('traditionalOwners', {
                                        rules: [{ required: true, message: 'Please enter traditional custodians!' }],
                                    })(
                                        <Input placeholder="Enter traditional custodians name" />
                                    )}
                                </FormItem>
                                <FormItem label="Profile Image">
                                    {getFieldDecorator('profileImage', {
                                        rules: [{ required: true, message: 'Please enter profile image!' }],
                                    })(
                                        <Upload
                                            name="avatar"
                                            listType="picture-card"
                                            className="avatar-uploader"
                                            showUploadList={false}
                                            beforeUpload={(file) => this.beforeUploadProfileImage(file)}
                                        >
                                            {profileImage ? <img src={profileImage} width="100" alt="profileImage" /> : uploadButton}
                                        </Upload>
                                    )}
                                </FormItem>
                                <FormItem label="Banner Image">
                                    {getFieldDecorator('bannerImage', {
                                        rules: [{ required: true, message: 'Please enter banner image!' }],
                                    })(
                                        <Upload
                                            name="avatar"
                                            listType="picture-card"
                                            className="avatar-uploader"
                                            showUploadList={false}
                                            beforeUpload={(file) => this.beforeUploadBannerImage(file)}
                                        >
                                            {bannerImage ? <img src={bannerImage} width="100" alt="bannerImage" /> : uploadButton}
                                        </Upload>
                                    )}
                                </FormItem>
                            </Col>

                            <Col sm={24} md={12} style={{ paddingInline: 10 }}>
                                <p className='epar_national_map_form_category'>Climate Champion Details</p>
                                <FormItem label="Climate Champion's Name">
                                    {getFieldDecorator('climateChampionName')(
                                        <Input placeholder="Enter climate champion's name" />
                                    )}
                                </FormItem>
                                <FormItem label="Description">
                                    {getFieldDecorator('climateChampionDescription')(
                                        <Input.TextArea placeholder="Enter description" />
                                    )}
                                </FormItem>
                                <FormItem label="Profile Image">
                                    {getFieldDecorator('climateChampionImage')(
                                        <Upload
                                            name="climateChampionImage"
                                            listType="picture-card"
                                            className="avatar-uploader"
                                            showUploadList={false}
                                            beforeUpload={(file) => this.beforeUploadClimateChampionImage(file)}
                                        >
                                            {climateChampionImage ? <img src={climateChampionImage} width="100" alt="climateChampionImage" /> : uploadButton}
                                        </Upload>
                                    )}
                                </FormItem>

                                <p className='epar_national_map_form_category'>Contact Details</p>
                                <FormItem label="Website">
                                    {getFieldDecorator('website')(
                                        <Input placeholder="Enter website" />
                                    )}
                                </FormItem>
                                <FormItem label="Phone Number">
                                    {getFieldDecorator('contactNumber')(
                                        <Input placeholder="Enter phone number" />
                                    )}
                                </FormItem>

                                <Row><div>Mark Area</div>
                                    <Button>Open Map</Button></Row>
                            </Col>
                        </div>
                        <Divider />
                        <Row justify="end" type="flex">
                            <Button type="default" onClick={this.handleCancel}>Cancel</Button>
                            <Button type="primary" onClick={this.handleSubmit} className="epar_national_map_submit-button">Save</Button>
                        </Row>
                    </Form>
                }
            </div>
        );
    }

    selectedOrg = () => {
        return (
            <div>
                {
                    this.state.nationalMapSiteType === SITE_TYPE.ORG_LEVEL &&
                    <Row>
                        <Col sm={24} md={12}>
                            <p className="epar_national_map_label">Organization :</p>
                            <Input value={this.props.orgInfo.name} disabled />
                        </Col>
                    </Row>
                }
            </div>
        );
    }

    selectedInstance = () => {
        return (
            <div>
                {
                    this.state.isNationalMapEnabled &&
                    <Row className="epar_national_map_row" type="flex">
                        <p className="epar_national_map_label">Instance :</p>
                        <Select disabled={this.state.nationalMapSites.length > 0} defaultValue={this.state.instanceType} style={{ width: 120 }} onChange={(instanceType) => this.setState({ instanceType })}>
                            {NATIONAL_MAP_INSTANCES.map(instance => (
                                <Option value={instance.key}>{instance.name}</Option>
                            ))}
                        </Select>
                    </Row>
                }
            </div>
        );
    }

    siteTypeSelector = () => {
        return (
            <div>
                {
                    this.state.isNationalMapEnabled &&
                    <Row>
                        <Col sm={24} md={16}>
                            <Row className="epar_national_map_row" type="flex">
                                <p className="epar_national_map_label">Enable By :</p>
                                <Radio.Group onChange={(event) => this.setState({ nationalMapSiteType: event.target.value })}>
                                    <Radio.Button
                                        className="epar_national_map_radio-button"
                                        value={SITE_TYPE.ORG_LEVEL}
                                        checked={this.state.nationalMapSiteType === SITE_TYPE.ORG_LEVEL}
                                        disabled={this.state.nationalMapSiteType === SITE_TYPE.OU_LEVEL}
                                    >
                                        Organization
                                    </Radio.Button>
                                    <Radio.Button
                                        className="epar_national_map_radio-button"
                                        value={SITE_TYPE.OU_LEVEL}
                                        checked={this.state.nationalMapSiteType === SITE_TYPE.OU_LEVEL}
                                        disabled={this.state.nationalMapSiteType === SITE_TYPE.ORG_LEVEL}
                                    >
                                        Organization Unit
                                    </Radio.Button>
                                </Radio.Group>
                            </Row>
                        </Col>
                        {
                            this.state.nationalMapSiteType === SITE_TYPE.OU_LEVEL &&
                            <Col sm={24} md={8}>
                                <Row className="epar_national_map_row" type="flex" align='bottom' justify='end'>
                                    <Button icon='plus' onClick={() => this.setState({ isShowOuSelector: true })}>Create Group</Button>
                                </Row>
                            </Col>
                        }
                    </Row>
                }
            </div>
        );
    }

    enableNationalMap = () => {
        return (
            <Row className="epar_national_map_row" type="flex">
                <p className="epar_national_map_label">Enable National map :</p>
                <Switch
                    checkedChildren={<Icon type="check" />}
                    unCheckedChildren={<Icon type="close" />}
                    checked={this.state.isNationalMapEnabled}
                    onChange={this.onEnableDisableSite}
                />
            </Row>
        );
    }

    siteDetailView = () => {
        return (
            <div>
                {this.state.selectedSite &&
                    <NationalMapDetailView site={this.state.selectedSite} />}
            </div>
        );
    }

    render() {
        return (
            <div>
                {
                    this.state.isLoading ?
                        <ConnectLoading /> :
                        <div className="epar_national_map">
                            {this.enableNationalMap()}
                            {this.siteTypeSelector()}
                            {this.orgOuSelector()}
                            {this.selectedInstance()}
                            {this.selectedOrg()}
                            {this.addNationalMapSiteForm()}
                            {this.orgGroupListView()}
                            {this.siteDetailView()}
                        </div>
                }
            </div>

        );
    }
}

function mapStateToProps(state, props) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(NationalMapSiteDetailsForm));